module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/perfect/perfect-10-29d7fc63fa163fe5440562113b3a931d.jpg";